import { api } from "./base";

export const orderPost = async ({ locale, values }) => {
  api.defaults.headers = { locale };
  const res = await api.post(`/order`, values);
  return res.data;
};
